require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-update-how-well-adapted-is-the-world-banks-work-on-climat.json") })
        }
      }, "path---en-us-update-how-well-adapted-is-the-world-banks-work-on-climat");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-update-how-well-adapted-is-the-world-banks-work-on-climat!./.cache/json/en-us-update-how-well-adapted-is-the-world-banks-work-on-climat.json
// module id = 741
// module chunks = 231608221292675